import { render, staticRenderFns } from "./user_shop_bundle_product_record.vue?vue&type=template&id=ba0b9584"
import script from "./user_shop_bundle_product_record.vue?vue&type=script&lang=js"
export * from "./user_shop_bundle_product_record.vue?vue&type=script&lang=js"
import style0 from "./user_shop_bundle_product_record.vue?vue&type=style&index=0&id=ba0b9584&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports